export const SET_ASKING = 'ROOM/ASKING/SET_ASKING'
export const SET_ASKINGS = 'ROOM/ASKING/SET_ASKINGS'
